<template>
    <b-button class="mb-2" v-on:click="goBack">
        <b-icon-chevron-left></b-icon-chevron-left>
        Назад
    </b-button>
</template>
<script>
import common from "../mixins/common";

export default {
  props: ["to"],
  name: 'back-button',
  mixins: [common],
  methods: {
    goBack() {
      if (this.inIframe()) {
        this.$router.go(-2)
      } else {
        if (this.to) {
          this.$router.push(this.to)
        } else {
          this.$router.back()
        }
      }
    }
  }
}
</script>
